import { useEffect } from 'react';
import { useGetPayphoneConfigQuery } from '../slices/payphoneApiSlice';
import '../../src/assets/styles/payphone-payment-box-corrected.css';

const PAYPHONE_SCRIPT_ID = 'payphone-script';

export const usePayPhoneBox = ({
    amount,
    amountWithTax,
    amountWithoutTax,
    tax,
    clientTransactionId,
    companyId,
    containerId = 'pp-button',
}) => {
    const { data, isSuccess } = useGetPayphoneConfigQuery(companyId);

    useEffect(() => {
        const missingParams = [];
        if (amount === null || amount === undefined) missingParams.push('amount');
        if (amountWithTax === null || amountWithTax === undefined) missingParams.push('amountWithTax');
        if (amountWithoutTax === null || amountWithoutTax === undefined) missingParams.push('amountWithoutTax');
        if (tax === null || tax === undefined) missingParams.push('tax');
        if (!clientTransactionId) missingParams.push('clientTransactionId');
        if (!companyId) missingParams.push('companyId');

        if (missingParams.length > 0) {
            console.warn(`⚠️ usePayPhoneBox: Missing or null values detected for: ${missingParams.join(', ')}`, {
                amount,
                amountWithTax,
                amountWithoutTax,
                tax,
                clientTransactionId,
                companyId,
            });
        }
    }, [amount, amountWithTax, amountWithoutTax, tax, clientTransactionId, companyId]);

    useEffect(() => {
        if (!isSuccess || !clientTransactionId) return;

        const { token, storeId } = data;

        const loadResources = () => {
            if (!window.__payPhoneScriptLoaded) {
                const script = document.createElement('script');
                script.type = 'module';
                script.src =
                    'https://cdn.payphonetodoesposible.com/box/v1.1/payphone-payment-box.js';
                script.id = PAYPHONE_SCRIPT_ID;
                script.onload = () => {
                    window.__payPhoneScriptLoaded = true;
                    renderPayPhoneButton({ token, storeId });
                };
                document.body.appendChild(script);
            } else {
                renderPayPhoneButton({ token, storeId });
            }
        };

        let retryCount = 0;
        const renderPayPhoneButton = ({ token, storeId }) => {
            try {
                const container = document.getElementById(containerId);
                if (container) {
                    if (window.PPaymentButtonBox) {
                        container.innerHTML = ''; 
                        new window.PPaymentButtonBox({
                            token,
                            clientTransactionId: clientTransactionId,
                            amount: Math.round(amount * 100),
                            amountWithTax: Math.round(amountWithTax * 100),
                            amountWithoutTax: Math.round(amountWithoutTax * 100),
                            tax: Math.round(tax * 100),
                            currency: 'USD',
                            storeId,
                            reference: 'Pago desde HomeSanty',
                        }).render(containerId);
                    }
                } else if (retryCount < 10) {
                    retryCount++;
                    setTimeout(() => renderPayPhoneButton({ token, storeId }), 100);
                }
            } catch (error) {
                console.error('Error al renderizar la cajita de pagos:', error);
            }
        };

        loadResources();
    }, [isSuccess, data, amount, amountWithTax, amountWithoutTax, tax, clientTransactionId, containerId]);
};
